import { Alert, Stack } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Dialog, DialogBody } from '../../common/components/Modal/Modal';
import { TraceType } from '../../common/enums/TraceType';
import { getErrorMessage } from '../../common/errors/errors';
import { UrlHelper } from '../../common/utils/UrlHelper';
import { Interpolation } from '../../config/i18n/components/Interpolation';
import { ProjectExceptionType } from '../../project-exceptions/enums/ProjectExceptionType';
import { ProjectExceptionRepository } from '../../project-exceptions/services/ProjectExceptionRepository';
import { EXTERNAL_URLS } from '../../routing/routes';
import { ExceptionForm } from '../components/ExceptionForm';

type Props = {
  projectId: number;
  onClosed: (exceptionId: number | undefined) => void;
};

export const CreateExceptionFlow = ({ projectId, onClosed }: Props) => {
  const [exceptionRepository] = useState(new ProjectExceptionRepository());
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    return () => {
      exceptionRepository.cancelAllRequests();
    };
  }, [exceptionRepository]);

  const handleSubmit = async (term: string, description: string | null, type: ProjectExceptionType, traceType: TraceType) => {
    try {
      setError(null);
      const exception = await exceptionRepository.createException(projectId, type, term, description, true, traceType);
      onClosed(exception.getId());
    } catch (e: unknown) {
      setError(getErrorMessage(e));
    }
  };

  return (
    <Dialog
      title={t('createException.title')}
      subtitle={
        <Interpolation
          i18nKey="exceptionsConsderations"
          items={[{ name: 'docs', href: UrlHelper.wrapExternalDocsUrl(EXTERNAL_URLS.DOCS_CREATE_EXCEPTIONS) }]}
          sx={{ lineHeight: 'inherit' }}
        />
      }
      onDismiss={() => onClosed(undefined)}
    >
      <DialogBody>
        <Stack spacing={1.5}>
          {error && <Alert severity="error">{error}</Alert>}
          <ExceptionForm
            submit={{ action: handleSubmit, label: t('createException.submit') }}
            back={{ action: () => onClosed(undefined), label: t('createException.back') }}
          />
        </Stack>
      </DialogBody>
    </Dialog>
  );
};
